import ExcelJS from 'exceljs';
import LogoNaranjo from '../images/LogoNaranjo.jpg';

const monthNames = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

export const exportTraceabilitySamplesToExcel = async (data, fileName = 'seguimiento_muestras') => {
  try {
    const workbook = new ExcelJS.Workbook();

    const groupDataByMonthYear = (data) => {
      const grouped = {};
      data.forEach((item) => {
        if (item.admission_date) {
          const date = new Date(item.admission_date);
          const month = date.getMonth() + 1;
          const year = date.getFullYear();
          const key = `${monthNames[month - 1]} - ${year}`;
          
          if (!grouped[key]) {
            grouped[key] = [];
          }
          grouped[key].push(item);
        }
      });
      
      return grouped;
    };

    const createWorksheet = (workbook, sheetName, sheetData) => {
      const worksheet = workbook.addWorksheet(sheetName);

      worksheet.columns = [
        { header: 'Empresa', key: 'company_name', width: 30 },
        { header: 'RUT empresa', key: 'company_document_number', width: 18 },
        { header: 'Sucursal', key: 'branch_office_name', width: 20 },
        { header: 'Nombre Trabajador', key: 'patient_full_name', width: 30 },
        { header: 'N° Documento', key: 'patient_document_number', width: 18 },
        { header: 'Tipo Documento', key: 'patient_document_type', width: 15 },
        { header: 'TENS Entrega PAFs', key: 'delivery_staff_pafs', width: 25 },
        { header: 'TENS Entrega Graham', key: 'delivery_staff_graham', width: 25 },
        { header: 'Fecha Entrega PAFs', key: 'delivery_date_pafs', width: 20 },
        { header: 'Fecha Entrega Graham', key: 'delivery_date_graham', width: 22 },
        { header: 'TENS Recibe PAFs', key: 'reception_staff_pafs', width: 25 },
        { header: 'TENS Recibe Graham', key: 'reception_staff_graham', width: 25 },
        { header: 'Fecha Recepción PAFs', key: 'reception_date_pafs', width: 22 },
        { header: 'Fecha Recepción Graham', key: 'reception_date_graham', width: 25 },
        { header: 'TENS Envia Lab, PAFs', key: 'lab_dispatch_staff_pafs', width: 25 },
        { header: 'TENS Envia Lab, Graham', key: 'lab_dispatch_staff_graham', width: 25 },
        { header: 'Fecha Envío Lab. PAFs', key: 'lab_dispatch_date_pafs', width: 22 },
        { header: 'Fecha Envío Lab. Graham', key: 'lab_dispatch_date_graham', width: 25 },
        { header: 'Entrega 1', key: 'delivery_status_pafs', width: 20 },
        { header: 'Recepción 1', key: 'reception_status_pafs', width: 20 },
        { header: 'Entrega 2', key: 'delivery_status_graham', width: 20 },
        { header: 'Recepción 2', key: 'reception_status_graham', width: 20 },
      ];

      worksheet.getRow(1).font = { bold: true, size: 12 };
      worksheet.getRow(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '#DC582A' },
      };
      worksheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
      worksheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getRow(1).height = 25;

      sheetData.forEach((item) => {
        worksheet.addRow({
          company_name: item.company_name || '',
          company_document_number: item.company_document_number || '',
          branch_office_name: item.branch_office_name || '',
          patient_full_name: item.patient_full_name || '',
          patient_document_number: item.patient_document_number || '',
          patient_document_type: item.patient_document_type || '',
          delivery_staff_pafs: item.delivery_staff_pafs || '',
          delivery_date_pafs: item.delivery_date_pafs || '',
          reception_staff_pafs: item.reception_staff_pafs || '',
          reception_date_pafs: item.reception_date_pafs || '',
          lab_dispatch_staff_pafs: item.lab_dispatch_staff_pafs || '',
          lab_dispatch_date_pafs: item.lab_dispatch_date_pafs || '',
          delivery_staff_graham: item.delivery_staff_graham || '',
          delivery_date_graham: item.delivery_date_graham || '',
          reception_staff_graham: item.reception_staff_graham || '',
          reception_date_graham: item.reception_date_graham || '',
          lab_dispatch_staff_graham: item.lab_dispatch_staff_graham || '',
          lab_dispatch_date_graham: item.lab_dispatch_date_graham || '',
          delivery_status_pafs: item.delivery_status_pafs || '',
          reception_status_pafs: item.reception_status_pafs || '',
          delivery_status_graham: item.delivery_status_graham || '',
          reception_status_graham: item.reception_status_graham || '',
        });
      });

      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };

          if (rowNumber > 1) {
            cell.alignment = { vertical: 'middle', horizontal: 'left' };
          }
        });
      });

      worksheet.autoFilter = {
        from: 'A1',
        to: 'T1',
      };

      return worksheet;
    };

    const groupedData = groupDataByMonthYear(data);

    const sortedKeys = Object.keys(groupedData).sort((a, b) => {
      
      const [monthA, yearA] = a.split(' - ');
      const [monthB, yearB] = b.split(' - ');
      
      const dateA = new Date(parseInt(yearA), monthNames.indexOf(monthA));
      const dateB = new Date(parseInt(yearB), monthNames.indexOf(monthB));
      
      return dateA - dateB;
    });

    if (sortedKeys.length === 0) {
      createWorksheet(workbook, 'Seguimiento de Muestras', data);
    } else {
      sortedKeys.forEach((key) => {
        createWorksheet(workbook, key, groupedData[key]);
      });
    }

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error('Error al generar el archivo Excel:', error);
    throw error;
  }
};

const laboratorySummaryColumnWidths = [15, 15, 15, 15, 15, 15, 70, 15];
const laboratorySummaryFirstPatientRow = 11;
const laboratorySummaryWhiteFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
const laboratorySummaryFonts = {
  title: { name: 'Arial', size: 13, bold: true },
  label: { name: 'Arial', size: 9, bold: true },
  body: { name: 'Arial', size: 8 },
  footer: { name: 'Arial', size: 8, bold: true },
};

const styleLaboratorySummaryRow = (worksheet, rowNumber, font, horizontal = 'left') => {
  const row = worksheet.getRow(rowNumber);
  for (let columnNumber = 1; columnNumber <= laboratorySummaryColumnWidths.length; columnNumber += 1) {
    const cell = row.getCell(columnNumber);
    cell.font = font;
    cell.fill = laboratorySummaryWhiteFill;
    cell.alignment = { horizontal };
  }
};

const addLaboratorySummaryLogo = async (workbook, worksheet) => {
  const response = await fetch(LogoNaranjo);
  const buffer = await response.arrayBuffer();
  const imageId = workbook.addImage({ buffer, extension: 'jpeg' });
  worksheet.addImage(imageId, { tl: { col: 1, row: 1 }, ext: { width: 230, height: 70 } });
};

const addLaboratorySummaryHeader = (worksheet, summary, t) => {
  [1, 2, 3, 4, 5].forEach((rowNumber) => styleLaboratorySummaryRow(worksheet, rowNumber, laboratorySummaryFonts.title, 'center'));
  worksheet.getCell('E4').value = t('examPage.laboratorySummary.title');

  worksheet.getCell('B6').value = t('examPage.laboratorySummary.branchOfficeLabel');
  worksheet.getCell('C6').value = summary.branch_office_name;
  worksheet.getCell('B7').value = t('examPage.laboratorySummary.dateLabel');
  worksheet.getCell('C7').value = summary.date;
  worksheet.getCell('D7').value = t('examPage.laboratorySummary.hourLabel', { hour: summary.hour });
  worksheet.getCell('B8').value = t('examPage.laboratorySummary.responsibleLabel');
  worksheet.getCell('C8').value = summary.responsible_name;
  [6, 7, 8].forEach((rowNumber) => styleLaboratorySummaryRow(worksheet, rowNumber, laboratorySummaryFonts.label));
};

const addLaboratorySummaryPatients = (worksheet, patients, t) => {
  styleLaboratorySummaryRow(worksheet, laboratorySummaryFirstPatientRow - 2, laboratorySummaryFonts.body);

  const headerRow = worksheet.getRow(laboratorySummaryFirstPatientRow - 1);
  ['names', 'lastName', 'documentNumber', 'birthdate', 'attentionHour', 'exams'].forEach((column, index) => {
    headerRow.getCell(index + 2).value = t(`examPage.laboratorySummary.columns.${column}`);
  });
  styleLaboratorySummaryRow(worksheet, laboratorySummaryFirstPatientRow - 1, laboratorySummaryFonts.label);

  patients.forEach((patient, index) => {
    const rowNumber = laboratorySummaryFirstPatientRow + index;
    const row = worksheet.getRow(rowNumber);
    [
      patient.names,
      patient.last_name,
      patient.document_number,
      patient.birthdate,
      patient.attention_hour,
      patient.exams,
    ].forEach((value, columnIndex) => {
      row.getCell(columnIndex + 2).value = value;
    });
    styleLaboratorySummaryRow(worksheet, rowNumber, laboratorySummaryFonts.body);
  });

  const lastPatientRow = laboratorySummaryFirstPatientRow + patients.length - 1;
  styleLaboratorySummaryRow(worksheet, lastPatientRow + 1, laboratorySummaryFonts.label);
  styleLaboratorySummaryRow(worksheet, lastPatientRow + 2, laboratorySummaryFonts.footer);
};

const downloadWorkbook = async (workbook, fileName) => {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const buildLaboratorySummaryWorkbook = async (summary, t) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(t('examPage.laboratorySummary.sheetName'));
  worksheet.columns = laboratorySummaryColumnWidths.map((width) => ({ width }));

  await addLaboratorySummaryLogo(workbook, worksheet);
  addLaboratorySummaryHeader(worksheet, summary, t);
  addLaboratorySummaryPatients(worksheet, summary.patients, t);

  return workbook;
};

export const exportLaboratorySummaryToExcel = async (summary, t) => {
  const workbook = await buildLaboratorySummaryWorkbook(summary, t);
  await downloadWorkbook(workbook, t('examPage.laboratorySummary.fileName'));
};
